import { WysiwygConfigType } from '@vk-hr-tek/ui/input';

export const wysiwygConfig: WysiwygConfigType = {
  plugins: {
    selectAllPlugin: {
      value: false,
      withDivider: false,
    },

    formatHeadingPlugin: {
      heading: false,
      fontColor: false,
      withDivider: false,
      backgroungColor: false,
    },

    formatTextPlugin: {
      bold: true,
      code: false,
      italic: true,
      underline: true,
      subscript: false,
      withDivider: true,
      superscript: false,
      strikethrough: true,
    },

    listAndFormatPlugin: {
      list: true,
      align: false,
      indent: false,
      withDivider: true,
    },

    linkAndTablePlugin: {
      link: true,
      table: false,
      quote: false,
      mention: false,
      symbols: false,
      reference: false,
      codeBlock: false,
      withDivider: false,
    },

    mediaPlugin: {
      file: false,
      video: false,
      singeImage: true,
      withDivider: false,
      imagesGallery: false,
    },

    undoRedoPlugin: true,

    trackMediaIdsAndMentionsPlugin: true,
  },
  mode: 'comments',
};
